import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const maidGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // maidGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.MAID) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const maidPlans = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // maidPlans is 2
    if (appID !== constAppID.MAID) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'maidQuote' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const maidRisk = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // maidRisk is 3
    if (appID !== constAppID.MAID) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'maidQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'maidQuotePlans' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const maidPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // maidPremium is 4
    if (appID !== constAppID.MAID) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 4) {
      if (quoteLifeCycle === 1) {
        next({ name: 'maidQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'maidQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'maidQuoteRisk' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const maidPayment = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // maidPayment is 5
    if (appID !== constAppID.MAID) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 5) {
      if (quoteLifeCycle === 1) {
        next({ name: 'maidQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'maidQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'maidQuoteRisk' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'maidQuotePremium' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
